module.exports = __webpack_public_path__ + "img/logo-full.ff8acc66.svg";